import { PROGRAMS } from "constant/program";
import { getAgencyUserPrincipalIds } from "./agency_user";

export const getIsAkapMaipUser = agencyUser =>
  [PROGRAMS.AKAP, PROGRAMS.MAIP].includes(agencyUser.overrides?.citizen_program?.program?.id);

export const getIsAkapUser = agencyUser => agencyUser.overrides?.citizen_program?.program?.id === PROGRAMS.AKAP;

export const getCanRedeemAkapMaipProgram = (citizen, agencyUser) => {
  if (!citizen?.codes?.length || !agencyUser) return false;

  const principalIds = getAgencyUserPrincipalIds(agencyUser);

  if (principalIds.size === 0) return false;

  return citizen.codes.some(code => {
    const programId = code?.program?.id;
    const isAkapOrMaip = [PROGRAMS.AKAP, PROGRAMS.MAIP].includes(programId);

    return isAkapOrMaip && principalIds.has(code?.user_id);
  });
};

export const getIsAkapOrMaipProgram = programId => {
  return [PROGRAMS.AKAP, PROGRAMS.MAIP].includes(programId);
};


export const formatPhoneNumber = value => {
  // format the input value as a Philippine phone number
  if (!value) return "";
  value = value.toString();
  if (value.startsWith("0")) return value.replace(/^0/, "63");
  if (value.startsWith("63")) return value;

  // setVal(`63${value}`);
  return `63${value}`;
};

export const parsePhoneNumber = value => {
  // parse the input value as a number
  if (!value) return 0;
  return value.toString().replace(/^(0|63)/, "");
};

export const isProgramVisible = (referralCode, agencyId) => {
  if (agencyId === 2 && referralCode?.code?.program?.id !== PROGRAMS.AKAP) return false;
  if (agencyId === 1 && referralCode?.code?.program?.id !== PROGRAMS.MAIP) return false;
  return true;
};
